import { Component } from '@angular/core';
import { LimitReportReviewOverviewBaseComponent } from '@backoffice-frontend/limit-report/domain';

@Component({
    selector: 'backoffice-frontend-limit-report-review-hkn-power-overview',
    templateUrl: './limit-report-review-hkn-overview.component.html',
    styleUrls: ['./limit-report-review-hkn-overview.component.scss'],
    standalone: false
})
export class LimitReportPowerReviewHknOverviewComponent extends LimitReportReviewOverviewBaseComponent {
  constructor() {
    super();
  }
}
